import React from 'react';

const HelpText = () => (
  <p>
    If you have any questions or comments please email <a href="mailto:help@visitops.com">help@visitops.com</a>
  </p>
);

export default HelpText;
